/**
 * @generated SignedSource<<fd857476131c0372823495eef22b20ab>>
 * @relayHash 0b3ab93ce67f2f873d66a3bad14734e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6296bdca1160c0740c8ce52e72bbcb463f6cef9a992e1bd6d0844ea2708c05ee

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSiteSkillsConnectionQuery$variables = {
  after?: string | null;
  agentAccountIds?: ReadonlyArray<string> | null;
  categoryIds?: ReadonlyArray<string> | null;
  cloudId: string;
  first?: number | null;
  query?: string | null;
};
export type useSiteSkillsConnectionQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSiteSkillsConnection_categories">;
};
export type useSiteSkillsConnectionQuery = {
  response: useSiteSkillsConnectionQuery$data;
  variables: useSiteSkillsConnectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAccountIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "agentAccountIds",
    "variableName": "agentAccountIds"
  },
  {
    "kind": "Variable",
    "name": "categoryIds",
    "variableName": "categoryIds"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSiteSkillsConnectionQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "FragmentSpread",
        "name": "useSiteSkillsConnection_categories"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSiteSkillsConnectionQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "AgentWorkspaceSkillCategoryConnection",
        "kind": "LinkedField",
        "name": "agentWorkspace_skillCategories",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentWorkspaceSkillCategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentWorkspaceSkillCategory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "skillCount"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "AgentWorkspaceSkillConnection",
                    "kind": "LinkedField",
                    "name": "skills",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AgentWorkspaceSkillEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AgentWorkspaceSkill",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              },
                              {
                                "concreteType": "AgentWorkspaceSkillAgentAssignment",
                                "kind": "LinkedField",
                                "name": "assignedAgents",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "AgentWorkspaceUser",
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v8/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                          },
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": "skills(first:20)"
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          (v10/*: any*/)
        ]
      },
      {
        "args": (v6/*: any*/),
        "filters": [
          "query",
          "categoryIds",
          "agentAccountIds"
        ],
        "handle": "connection",
        "key": "useSiteSkillsConnection__agentWorkspace_skillCategories",
        "kind": "LinkedHandle",
        "name": "agentWorkspace_skillCategories"
      }
    ]
  },
  "params": {
    "id": "6296bdca1160c0740c8ce52e72bbcb463f6cef9a992e1bd6d0844ea2708c05ee",
    "metadata": {},
    "name": "useSiteSkillsConnectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d30518811c5dd0412c3e6dc27b7702e";

export default node;
